import React from 'react';
import { 
  FaUserMd, 
  FaStethoscope, 
  FaGraduationCap, 
  FaAward,
  FaStar,
  FaBriefcaseMedical,
  FaHandsHelping,
  FaCalendarCheck,
  FaPhoneAlt
} from 'react-icons/fa';
import '../style.css';

const DoctorsSection = () => {
  const doctors = [
    {
      id: 1,
      name: "Dr. Sweta Rai",
      title: "Gynecology & Infertility Specialist",
      image: "sweta.png",
      education: "MD - Obstetrics & Gynecology",
      specializations: [
        "Infertility Treatment",
        "High-Risk Pregnancy Care",
        "Laparoscopic Surgery",
        "IVF & IUI Procedures"
      ],
      achievements: [
        "Best Gynecologist Award 2023",
        "Women's Health Excellence Award"
      ],
      description: "Leading infertility specialist with extensive experience in advanced reproductive technologies and maternal healthcare in Varanasi.",
      contact: "Mon-Sat: 9AM - 6PM",
      phone: "+91 80903 11155",
      color: "pink"
    },
    {
      id: 2,
      name: "Dr. Sandeep Kumar Rai",
      title: "Neurosurgeon & Spine Specialist",
      image: "sandeep.png",
      education: "MCh - Neurosurgery",
      specializations: [
        "Brain Tumor Surgery",
        "Spine & Disc Surgery",
        "Minimally Invasive Neurosurgery",
        "Pediatric Neurosurgery"
      ],
      achievements: [
        "Excellence in Neurosurgery Award",
        "Spine Surgery Pioneer Award"
      ],
      description: "Renowned neurosurgeon specializing in complex brain and spine surgeries with international training and expertise.",
      contact: "Mon-Fri: 10AM - 7PM",
      phone: "+91 80903 11155",
      color: "blue"
    }
  ];

  return (
    <section className="rockland-doctors-cards">
      {/* Header */}
      <div className="rockland-cards-header">
        <div className="rockland-cards-header-content">
          <h2 className="rockland-cards-subtitle">
            <FaUserMd className="rockland-cards-header-icon" /> Professional Team
          </h2>
          <h1 className="rockland-cards-title">Meet Our Doctors</h1>
          <p className="rockland-cards-description">
            Our expert medical team dedicated to providing exceptional healthcare in Varanasi
          </p>
          <div className="rockland-cards-divider">
            <div className="rockland-cards-divider-line"></div>
            <FaStar className="rockland-cards-divider-star" />
            <div className="rockland-cards-divider-line"></div>
          </div>
        </div>
      </div>

      {/* Doctors Cards Container */}
      <div className="rockland-cards-container">
        {doctors.map((doctor) => (
          <div key={doctor.id} className={`rockland-doctor-card-item ${doctor.color}`}>
            {/* Image Card */}
            <div className="rockland-doctor-image-card">
              <div className="rockland-image-card-wrapper">
                <img 
                  src={doctor.image} 
                  alt={doctor.name}
                  className="rockland-doctor-profile-img"
                  onError={(e) => {
                    e.target.src = 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&h=700&q=80';
                  }}
                />
                <div className="rockland-image-card-overlay"></div>
                
                <div className="rockland-image-card-content">
                 
                  
                  <div className="rockland-image-card-info">
                    <h3 className="rockland-card-name">{doctor.name}</h3>
                    <p className="rockland-card-title">{doctor.title}</p>
                    
                    <div className="rockland-card-education">
                      <FaGraduationCap className="rockland-card-edu-icon" />
                      <span>{doctor.education}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Details Card */}
            <div className="rockland-doctor-details-card">
              <div className="rockland-details-card-content">
                <div className="rockland-details-header">
                  <h3 className="rockland-details-name">{doctor.name}</h3>
                  <p className="rockland-details-title">{doctor.title}</p>
                </div>
                
                <p className="rockland-details-bio">
                  {doctor.description}
                </p>
                
                <div className="rockland-details-sections">
                  <div className="rockland-details-section">
                    <h4 className="rockland-section-title">
                      <FaHandsHelping className="rockland-section-icon" /> Specializations
                    </h4>
                    <div className="rockland-section-content">
                      {doctor.specializations.map((spec, index) => (
                        <div key={index} className="rockland-spec-item">
                          <div className="rockland-spec-bullet"></div>
                          <span>{spec}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="rockland-details-section">
                    <h4 className="rockland-section-title">
                      <FaAward className="rockland-section-icon" /> Achievements
                    </h4>
                    <div className="rockland-section-content">
                      {doctor.achievements.map((award, index) => (
                        <div key={index} className="rockland-award-item">
                          <FaStar className="rockland-award-star" />
                          <span>{award}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                
                <div className="rockland-details-contact">
                  <div className="rockland-contact-info">
                    <div className="rockland-contact-item">
                      <FaCalendarCheck className="rockland-contact-icon" />
                      <span>{doctor.contact}</span>
                    </div>
                    <div className="rockland-contact-item">
                      <FaPhoneAlt className="rockland-contact-icon" />
                      <span>{doctor.phone}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DoctorsSection;